module.exports = __webpack_public_path__ + "img/alarme.2dd6fce3.svg";